// Get references to the navbar and hero elements
const navbar = document.querySelector("#navbar[data-transparent='true']");

if (navbar) {
	const hero = document.querySelector(".hero");
	if (hero) {
		// Create an Intersection Observer
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				navbar.setAttribute("data-transparent", entry.isIntersecting);
			});
		});

		// Observe the hero section
		observer.observe(hero, {
			threshold: 0.2,
		});
	}
}
